// Tipos para rutinas de ejercicios - Alineados con el backend

// Enums del backend
export enum RoutineIntensity {
  LOW = 'low',
  MODERATE = 'moderate',
  HIGH = 'high',
  VERY_HIGH = 'very_high',
}

export enum RoutineStatus {
  PLANNED = 'planned',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  SKIPPED = 'skipped',
}

export enum ExerciseType {
  SETS_REPS = 'sets_reps',
  TIME_BASED = 'time_based',
  DISTANCE = 'distance',
  REPS_ONLY = 'reps_only',
}

// Tipos de ejercicio según el backend (específico para rutinas)
export interface RoutineExerciseInfo {
  id: string;
  name: string;
  description?: string;
  category: string;
  muscleGroups: string[]; // Cambiado para coincidir con el backend
  equipment?: string[];
  instructions?: string[];
  difficulty: string;
  imageUrl?: string;
}

export interface RoutineExercise {
  id: string;
  dailyRoutineId: string;
  exercise: RoutineExerciseInfo;
  exerciseId: string;
  orderInRoutine: number;
  exerciseType: ExerciseType;
  sets?: number;
  reps?: number;
  weight?: string; // Decimal como string
  duration?: number; // En segundos
  distance?: number; // En metros
  restSeconds?: number;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Nivel de quien entrena. Ortogonal a `RoutineIntensity`, que describe la
 * periodización del día (lunes fuerza, jueves hipertrofia) y la fija el
 * generador, no el usuario.
 */
export type RoutineDifficulty = 'beginner' | 'intermediate' | 'advanced';

export const ROUTINE_DIFFICULTIES: readonly RoutineDifficulty[] = [
  'beginner',
  'intermediate',
  'advanced',
];

export const DIFFICULTY_LABELS: Record<RoutineDifficulty, string> = {
  beginner: 'Principiante',
  intermediate: 'Intermedio',
  advanced: 'Avanzado',
};

export interface DailyRoutine {
  id: string;
  name: string;
  description?: string;
  difficulty: RoutineDifficulty;
  routineDate: string; // Fecha en formato ISO
  intensity: RoutineIntensity;
  status: RoutineStatus;
  estimatedDurationMinutes?: number;
  estimatedCalories?: number;
  // Ojo con la caja: la API los manda asi (`warmUpNotes`). Estuvieron
  // escritos `warmupNotes` y por eso no se pintaba ninguno de los dos.
  warmUpNotes?: string;
  coolDownNotes?: string;
  goals?: string[];
  /** 0 domingo … 6 sábado en las siete rutinas fijas; ausente en el resto. */
  dayOfWeek?: number | null;
  routineExercises: RoutineExercise[];
  createdAt: string;
  updatedAt: string;
}

// Tipos adicionales para la UI
export interface RoutineStats {
  totalExercises: number;
  estimatedDuration: number;
  estimatedCalories: number;
  muscleGroups: string[];
}

// Mantener compatibilidad con el código existente
export type WorkoutRoutine = DailyRoutine;
